
export const QueryString = new URLSearchParams(window.location.search);